<a
    href="https://www.youtube.com/channel/UC-sXkznjkmHLjpA5nlfdswg/featured"
    target="_blank"
>
    <svg
        width="50"
        height="35"
        viewBox="0 0 50 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-8 md:w-9 lg:w-10 h-8 md:h-9 lg:h-10 hover:cursor-pointer"
    >
        <path
            d="M48.8941 5.46736C48.6098 4.40865 48.0525 3.44318 47.2779 2.66756C46.5032 1.89193 45.5384 1.33337 44.4801 1.04777C40.5844 2.04098e-07 24.9682 0 24.9682 0C24.9682 0 9.35191 -2.04098e-07 5.45621 1.0422C4.39741 1.32687 3.43214 1.88513 2.65736 2.66089C1.88257 3.43666 1.32554 4.40262 1.0422 5.46178C-2.04098e-07 9.36306 0 17.5 0 17.5C0 17.5 -2.04098e-07 25.6369 1.0422 29.5326C1.61624 31.6839 3.31051 33.3782 5.45621 33.9522C9.35191 35 24.9682 35 24.9682 35C24.9682 35 40.5844 35 44.4801 33.9522C46.6314 33.3782 48.3201 31.6839 48.8941 29.5326C49.9363 25.6369 49.9363 17.5 49.9363 17.5C49.9363 17.5 49.9363 9.36306 48.8941 5.46736ZM20.008 24.9682V10.0318L32.9379 17.4443L20.008 24.9682Z"
            fill="#694C15"
        />
    </svg>
</a>
